import React from "react"
import { injectIntl } from "react-intl"
import { Box, Typography } from "@material-ui/core"
import { Button } from "@ridecell/web-components-material"
import { useHistory } from "react-router-dom"

import messages from "./messages"

const NotFoundPage = ({ intl: { formatMessage } }) => {
  const history = useHistory()

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems={"center"}
      flexDirection="column"
      style={{ minHeight: "100vh", maxWidth: "100%" }}
    >
      <Typography variant="h6">
        {formatMessage(messages.notFoundMessage)}
      </Typography>
      <Button
        color="primary"
        size="large"
        onClick={() => history.push("/")}
        variant="contained"
      >
        {formatMessage(messages.goToHome)}
      </Button>
    </Box>
  )
}

export default injectIntl(NotFoundPage)
